const IN_PROGRESS_PROJECT = {id: 1, title: 'In progress'}
const DELAYED_PROJECT = {id: 2, title: 'Delayed'}
const COMPLETED_PROJECT = {id: 3, title: 'Completed'}
const LOST_PROJECT = {id: 4, title: 'Lost'}
const SEMI_COMPLETED_PROJECT = {id: 5, title: 'Semi-Completed'}
const PENDING_PROJECT = {id: 6, title: 'Pending'}
const DELETE_STATUS = {id: 7, title: 'Delete'}
const NOT_PAID = {id: 8, title: 'Not Paid'}

const projectStatuses = [
  IN_PROGRESS_PROJECT,
  DELAYED_PROJECT,
  COMPLETED_PROJECT,
  LOST_PROJECT,
  SEMI_COMPLETED_PROJECT,
  PENDING_PROJECT
]

export default projectStatuses
export {
  IN_PROGRESS_PROJECT,
  DELAYED_PROJECT,
  COMPLETED_PROJECT,
  LOST_PROJECT,
  SEMI_COMPLETED_PROJECT,
  PENDING_PROJECT,
  DELETE_STATUS,
  NOT_PAID
}



// WEBPACK FOOTER //
// ./src/constants/projectStatuses.js